<script>
import {defineComponent} from 'vue'
import TwButton from '@/components/generic/tw-button.vue'
import { useApiTokenStore } from '@/stores/apiTokens.js'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import RedpodiumApiTokensModal from '@/components/api-keys/integration-examples/redpodium-api-tokens-modal.vue'
import ApiKeyListGroupItem from '@/components/api-keys/api-key-list-group-item.vue'

export default defineComponent({
  name: 'ApiTokensIndexPage',
  components: { ApiKeyListGroupItem, RedpodiumApiTokensModal, TwLoadingSpinner, TwListGroupItem, TwListGroup, TwButton },
  props: {
    tokenable: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      LoadingCreatingApiKey: false,
      LoadingFetchingApiKeys: false,
      ValidationErrorMessage: null,
    }
  },
  computed :{
    apiTokens() {
      return useApiTokenStore().getItemByTokenable(this.tokenable)
    }
  },
  mounted() {
    this.fetchApiKeys()
  },
  methods: {
    async fetchApiKeys() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingApiKeys = true
        await useApiTokenStore().fetchItems({
          tokenable_type: this.tokenable.object_type,
          tokenable_id: this.tokenable.id
        })
        this.LoadingFetchingApiKeys = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingApiKeys = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }

    },
    async createApiKey() {
      try {
        this.ValidationErrorMessage = null
        this.LoadingCreatingApiKey = true
        await useApiTokenStore().itemCreate({
          tokenable_type: this.tokenable.object_type,
          tokenable_id: this.tokenable.id
        })
        this.LoadingCreatingApiKey = false
      } catch (e) {
        console.error(e)
        this.LoadingCreatingApiKey = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
})
</script>

<template>
  <div>
    <tw-button :loading="LoadingCreatingApiKey" class="float-right" variant="primary" @click="createApiKey">
      Create Api Key
    </tw-button>
    <div class="mb-4">
      Manage your API Tokens for <span class="font-bold">{{ tokenable.name_for_api_token }}. </span>
    </div>
    <div>
      <p v-if="!apiTokens || apiTokens.length === 0" class="text-gray-600 mb-4">
        No API keys found. Create a new key to get started.
      </p>
      <tw-loading-spinner v-if="LoadingFetchingApiKeys" />
      <tw-list-group v-if="apiTokens && apiTokens.length > 0">
        <api-key-list-group-item v-for="apiKey in apiTokens" :key="'api-key-' + apiKey.id" :api-key="apiKey" />
      </tw-list-group>
    </div>
  </div>
</template>

<style scoped>

</style>
